import { getRtokenInfo } from '@/api';
import { useEffect, useState } from 'react';
import CardHead from '../cardHead';
import LoadingOutlined from '../loadingOutlined';
import './index.scss';
export default function Index() {

    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<any>();



    useEffect(() => {
        setLoading(true)
        getRtokenInfo().then((res) => { 
            if (res.data.status == "80000") {
                setData(res.data.data.userInfo)
            }
        }).finally(() => {
            setLoading(false)
        })
    },[])


    return <div className="uniqueUsersContainer">
        <CardHead title="Unique Users" tips={`Overall users for StaFi Chain and StaFiHub`} />
        <div className="uniqueUsers-vlue">
            <LoadingOutlined spin={loading}> {data?.amount}</LoadingOutlined>
        </div>
        <div className='bottom'>
            <label> <LoadingOutlined spin={loading}>+ {data?.addAmount}</LoadingOutlined></label> Last Week
        </div>
    </div>
}